export const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export function to24h(hour: number, period: "AM" | "PM"): number {
  if (hour === 12) {
    return period === "AM" ? 0 : 12;
  }

  return hour + (period === "PM" ? 12 : 0);
}

export function to12h(hour24: number): { hour: number; period: "AM" | "PM" } {
  if (hour24 === 0) return { hour: 12, period: "AM" };
  if (hour24 === 12) return { hour: 12, period: "PM" };
  if (hour24 < 12) return { hour: hour24, period: "AM" };

  return { hour: hour24 - 12, period: "PM" };
}

export function getBlockedHours(from24: number, to24: number): number[] {
  const blocked: number[] = [];

  if (from24 <= to24) {
    for (let i = from24; i <= to24; i++) blocked.push(i);
  } else {
    for (let i = from24; i < 24; i++) blocked.push(i);
    for (let i = 0; i <= to24; i++) blocked.push(i);
  }

  return blocked;
}

export function toUTC(hour: number, offset: string = "0:00"): number {
  const offsetStr = offset || "0:00";
  const parts = offsetStr.split(":");
  const hours = parts[0] || "0";
  const offsetHours = Number.parseInt(hours, 10);

  let utcHour = hour - offsetHours;

  if (utcHour < 0) utcHour += 24;
  if (utcHour >= 24) utcHour -= 24;

  return utcHour;
}

export function fromUTC(hourUTC: number, offset: string = "0:00"): number {
  const offsetStr = offset || "0:00";
  const parts = offsetStr.split(":");
  const hours = parts[0] || "0";
  const offsetHours = Number.parseInt(hours, 10);

  let localHour = hourUTC + offsetHours;

  if (localHour < 0) localHour += 24;
  if (localHour >= 24) localHour -= 24;

  return localHour;
}
